import type { UnitNotification } from "./unitNotifications";

/**
 * Las notificaciones de UNA unidad dentro de la bandeja de la campana. Se
 * empata por equipo (device_id, lo que manda V5-realtime) y, si falta, por
 * vehículo: una notificación de geocerca o viaje puede venir sólo con vehículo.
 *
 * shortcut: sale de la misma bandeja (las últimas 50 del usuario en toda la
 * flota), así el número de la unidad siempre cuadra con la campana global;
 * una no leída más vieja que esas 50 no cuenta. Subir el tope duplica las
 * lecturas (se refresca cada minuto por usuario); si se queda corto, contar
 * por unidad en el servidor.
 */
export const unitItems = (items: UnitNotification[], deviceId: string, vehicleId?: string | null) =>
  items.filter((n) => n.device_id === deviceId || (!!vehicleId && !n.device_id && n.vehicle_id === vehicleId));

export const unreadLabel = (n: number) => (n > 9 ? "9+" : String(n));
